import { useEffect } from "react";
import Typed from "typed.js";
import { useTranslation } from "next-i18next";
import { useAppContext } from "@/src/config/AppProvider";

const BannerSection = () => {
  const { t } = useTranslation();
  const { licenceSettings, getLocalization } = useAppContext();

  useEffect(() => {
    const typeitInstance = new Typed(".is-visible", {
      strings: [`${t("aboutUs")}.`, `${t("vision")}.`, `${t("mission")}.`],
      typeSpeed: 80,
      backSpeed: 60,
      startDelay: 200,
      loop: true,
      showCursor: false
    });

    return () => {
      typeitInstance.destroy();
    };
  }, []);

  return (
    <div className="rbt-banner-area rbt-banner-8 variation-02">
      <div className="container">
        <div className="row g-5 align-items-center">
          <div className="col-lg-10 offset-lg-1">
            <div className="content">
              <div className="inner text-center">
                <div className="rbt-new-badge rbt-new-badge-one">{getLocalization("homeEmphasis")}</div>
                <h1 className="title">
                  {licenceSettings.SiteTitle}
                  <span className="header-caption ms-2">
                    <span className="cd-headline clip is-full-width">
                      <span className="cd-words-wrapper">
                        <b className="is-visible theme-gradient"></b>
                      </span>
                    </span>
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerSection;
